import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbStep } from '../shared/components/breadcrumb/breadcrumb.model';
import { ROUTES_NAMES, BREAD_STEPS } from './rattachement.model';

@Component({
  selector: 'jhi-rattachement',
  templateUrl: './rattachement.component.html',
  styleUrls: ['./rattachement.component.scss']
})
export class RattachementComponent implements OnInit {

  steps: Array<BreadcrumbStep> = [
    {
      label: BREAD_STEPS.AVERTISSEMENTS,
      route: `/rattachement/${ROUTES_NAMES.AVERTISSEMENTS}`,
      isActive: true
    },
    {
      label: BREAD_STEPS.REJOINDRE_DOSSIER,
      route: `/rattachement/${ROUTES_NAMES.REJOINDRE_DOSSIER}`,
      isActive: false
    },
    {
      label: BREAD_STEPS.CONFIRMATION,
      route: `/rattachement/${ROUTES_NAMES.CONFIRMATION}`,
      isActive: false
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.router.navigate([`/rattachement/${ROUTES_NAMES.AVERTISSEMENTS}`]);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/rattachement.component.ts